import { z } from 'zod';
import { Block, BlockSchema } from './Block.types';

import { LogoBarBlockConfigSchema, BlockType } from './blockConfig/Types';

export const LogoBarBlockSchema = BlockSchema.extend({
  blockConfig: LogoBarBlockConfigSchema,
});

export type LogoBarBlock = z.infer<typeof LogoBarBlockSchema>;

export function isLogoBarBlock(block: Block): block is LogoBarBlock {
  return block.blockConfig.type === BlockType.LogoBar;
}
